import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewEncapsulation
} from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import {
  sqaContent,
  validateAnswerRequest
} from './models/recover-by-security-questions.interface';
@Component({
  selector: 'idp-recover-by-security-questions',
  templateUrl: './recover-by-security-questions.component.html',
  styleUrls: ['./recover-by-security-questions.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class RecoverBySecurityQuestionsComponent implements OnInit {
  @Output() formSubmitEvent: EventEmitter<validateAnswerRequest> =
    new EventEmitter<validateAnswerRequest>();

  @Input() content: sqaContent | null | undefined = {} as sqaContent;
  form!: UntypedFormGroup | undefined;
  @Output() fieldFocusOut: EventEmitter<string> = new EventEmitter<string>();
  @Output() closeOverlayMessage: EventEmitter<void> = new EventEmitter<void>();

  errorMessage!: string;
  question1Text!: string;
  question2Text!: string;
  securityQuestionNbr1 = '';
  securityQuestionNbr2 = '';
  formNameSubmitted = '';
  @Output() inputChange: EventEmitter<string> = new EventEmitter<string>();

  @Output() focusInvalidField: EventEmitter<string> =
    new EventEmitter<string>();

  ngOnInit(): void {
    this.content?.pageContent?.pageHeader;
    this.checkContent();
  }

  // eslint-disable-next-line complexity
  checkContent() {
    if (
      this.content &&
      this.content.sqaStoredQuestionList &&
      this.content.sqaStoredQuestionList.securityQuestionList
    ) {
      (this.securityQuestionNbr1 =
        this.content?.sqaStoredQuestionList?.securityQuestionList[0]
          .questionNumber ?? this.securityQuestionNbr1),
        (this.securityQuestionNbr2 =
          this.content?.sqaStoredQuestionList?.securityQuestionList[1]
            ?.questionNumber ?? this.securityQuestionNbr1),
        (this.formNameSubmitted =
          this.content?.sqaStoredQuestionList?.formNameSubmitted ??
          this.formNameSubmitted);
    }
  }

  onClosePop() {
    this.closeOverlayMessage.emit();
  }

  submit() {
    const userInputFields: validateAnswerRequest = {
      tlMaskInfo_answer1: this.content?.formGroup?.get('answer1')?.value?.value,
      tlMaskInfo_answer2: this.content?.formGroup?.get('answer2')?.value?.value,
      securityQuestionNbr1: this.securityQuestionNbr1,
      securityQuestionNbr2: this.securityQuestionNbr2,
      formNameSubmitted: this.formNameSubmitted
    };

    this.formSubmitEvent.emit(userInputFields);
  }

  onChange() {
    this.inputChange.emit();
  }

  onFocussedOut(fieldName: string) {
    this.fieldFocusOut.emit(fieldName);
  }

  public get showErrorMessageQuestionOne() {
    const control: UntypedFormControl = <UntypedFormControl>(
      this.content?.formGroup?.get('answer1')
    );

    return (
      control &&
      this.content?.sqaFormAttributes?.answer1ControlTouched &&
      control.invalid
    );
  }

  onFocusFirstInvalidField() {
    this.focusInvalidField.emit();
  }

  public get showErrorMessageQuestionTwo() {
    const control: UntypedFormControl = <UntypedFormControl>(
      this.content?.formGroup?.get('answer2')
    );

    return (
      control &&
      this.content?.sqaFormAttributes?.answer2ControlTouched &&
      control.invalid
    );
  }
}
